export default __webpack_public_path__ + "media/images/paylogos/color/maestro-a3655535dee405ba1b883efa1346a32e.png";